import { render, staticRenderFns } from "./About-content-new.vue?vue&type=template&id=02577577&scoped=true"
import script from "./About-content-new.vue?vue&type=script&lang=js"
export * from "./About-content-new.vue?vue&type=script&lang=js"
import style0 from "./About-content-new.vue?vue&type=style&index=0&id=02577577&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02577577",
  null
  
)

export default component.exports